import { render } from "./shareTest.vue?vue&type=template&id=f31cf410"
import script from "./shareTest.vue?vue&type=script&lang=js"
export * from "./shareTest.vue?vue&type=script&lang=js"

import exportComponent from "F:\\webStorm workspace\\ujk_tangying\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__